import { InputText } from "primereact/inputtext"
import styles from "../../../styles/Participant-Employment.module.css"
import { checkErrorValidation } from "./formikAux"
const TextField = ({
  label,
  value,
  setValue,
  valueName,
  error,
  required,
  size,
  disabled,
}) => {
  return (
    <>
      <div
        className={styles.field}
        style={{ marginBottom: "0rem", width: `${size ? size : "100"}%` }}
      >
        <label
          className={`${styles.label} ${required && styles.requiredField}`}
          style={{ marginBottom: "5px" }}
        >
          {label}
        </label>
        <InputText
          value={value}
          style={{ width: "100%" }}
          disabled={disabled}
          onChange={(e) => {
            valueName
              ? setValue(valueName, e.target.value)
              : setValue(e.target.value)
          }}
          className={checkErrorValidation(error) ? "p-invalid" : ""}
        />
        {checkErrorValidation(error) && error}
      </div>
    </>
  )
}
export default TextField
